import _get from "./get";
import _put from "./put";

const AssetsManager = {
  _get,
  _put,
};

export default AssetsManager;
